import 'vite/modulepreload-polyfill'
import './main.sass'

(() => console.log('💙 TamToMy dev was here 👀'))();

document.querySelectorAll('p').forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.trim() === '') {
        p.style.display = 'none'
    }
});

(() => {
    const BP = 768
    const header = document.querySelector('.p-detail-inner-header')
    const productTop = document.querySelector('.product-top')
    if (!header || !productTop) return

    const originalParent = header.parentElement
    const placeholder = document.createComment('p-detail-inner-header-placeholder')

    const throttle = (fn, wait=150) => {
        let t = 0
        return () => {
            const now = Date.now()
            if (now - t > wait) { t = now; fn() }
        }
    }

    function updatePadding() {
        if (window.innerWidth <= BP) {
            productTop.style.setProperty('--hdrH', header.offsetHeight + 'px')
        } else {
            productTop.style.removeProperty('--hdrH')
        }
    }

    function relocate() {
        if (window.innerWidth <= BP) {
            if (header.parentElement !== productTop) {
                originalParent.insertBefore(placeholder, header)
                productTop.prepend(header)
            }
        } else {
            if (placeholder.parentNode) {
                placeholder.parentNode.insertBefore(header, placeholder)
                placeholder.remove()
            } else if (header.parentElement !== originalParent) {
                originalParent.prepend(header)
            }
        }
        updatePadding()
    }

    relocate()
    window.addEventListener('resize', throttle(relocate))
    window.addEventListener('load', relocate)
})();





function getStoresFromDOM() {
    const sections = document.querySelectorAll('.prodejny-list .prodejna-mesto');
    const stores = [];

    sections.forEach(section => {
        const cityEl = section.querySelector('.prodejna-nazev');
        if (!cityEl) return;

        const city = cityEl.textContent.trim();
        const paragraphs = section.querySelectorAll('p');

        paragraphs.forEach(p => {
            const fullText = p.textContent.trim();
            if (!fullText) return;

            const link = p.querySelector('a');
            let name, addressPart;

            if (link) {
                name = link.textContent.trim();
                addressPart = fullText.replace(name, '').replace(/^,\s*/, '');
            } else {
                const parts = fullText.split(',');
                name = parts[0].trim();
                addressPart = parts.slice(1).join(',').trim();
            }

            if (!addressPart) return;

            stores.push({
                city,
                name,
                address: `${addressPart}, ${city}, Česká republika`
            });
        });
    });

    return stores;
}


const MAP_STYLE = [
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            { "visibility": "on" },
            { "color": "#e0efef" }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            { "visibility": "on" },
            { "hue": "#1900ff" },
            { "color": "#c0e8e8" }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            { "lightness": 100 },
            { "visibility": "simplified" }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            { "visibility": "off" }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            { "visibility": "on" },
            { "lightness": 700 }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            { "color": "#7dcdcd" }
        ]
    }
];


function initStoresMap() {
    const mapElement = document.querySelector(".prodejny-map");
    if (!mapElement) return;

    const map = new google.maps.Map(mapElement, {
        center: { lat: 49.8, lng: 15.5 },
        zoom: 7,
        mapTypeControl: false,
        streetViewControl: false,
        styles: MAP_STYLE,
        scrollwheel: true,
        gestureHandling: "greedy"
    });

    let fixedCenter = map.getCenter();

    map.addListener("idle", () => {
        fixedCenter = map.getCenter();
    });

    map.addListener("zoom_changed", () => {
        map.setCenter(fixedCenter);
    });

    const geocoder = new google.maps.Geocoder();
    const infoWindow = new google.maps.InfoWindow();

    const heartIcon = {
        url: "/user/documents/upload/pinmap.svg",
        scaledSize: new google.maps.Size(34, 34),
        anchor: new google.maps.Point(17, 34)
    };

    const STORES = getStoresFromDOM();

    STORES.forEach((store) => {
        geocoder.geocode({ address: store.address }, (results, status) => {
            if (status === "OK" && results[0]) {
                const marker = new google.maps.Marker({
                    map,
                    position: results[0].geometry.location,
                    title: `${store.name} (${store.city})`,
                    icon: heartIcon
                });

                const content = `
                  <div style="font-size:14px; line-height:1.4">
                    <strong>${store.name}</strong><br>
                    ${store.city}<br>
                    ${store.address}
                  </div>
                `;

                marker.addListener("click", () => {
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);
                });
            } else {
                console.warn("Geocoding failed for", store, status);
            }
        });
    });
}

window.addEventListener("load", () => {
    initStoresMap();
});


window.addEventListener("load", () => {
    initStoresMap();
});


window.addEventListener('load', () => {
    const instaBlock = document.querySelector('.custom-footer__instagram');
    const target = document.getElementById('hp-instagram-target');

    if (!instaBlock || !target) return;

    const widget = instaBlock.querySelector('.instagram-widget');
    if (!widget) {
        target.appendChild(instaBlock);
        return;
    }

    if (widget.children.length > 0) {
        target.appendChild(instaBlock);
        return;
    }

    const observer = new MutationObserver(() => {
        if (widget.children.length > 0) {
            observer.disconnect();
            target.appendChild(instaBlock);
        }
    });

    observer.observe(widget, { childList: true });

    setTimeout(() => {
        if (instaBlock.parentNode !== target) {
            target.appendChild(instaBlock);
        }
        observer.disconnect();
    }, 5000);
});

//--------bannery ve výpisu produktů

